<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col
    md="12"
    class="pa-3 d-flex flex-column"
    v-if="this.condition()"

  >
<a class="anchor" id="bloctourisme"></a>

    <v-card elevation="2">
       <v-card-title>Etablissement Certifié &nbsp; Qualité Tourisme </v-card-title>
      <v-card-text >
        <a href="https://www.qualite-tourisme.gouv.fr/" target="_blank">
        <img
                title="Etablissement certifié Qualité Tourisme"
                src="../../assets/logo_qualite_tourisme.png"
        />
        </a>
         <v-simple-table>
            <tbody>

             <tr>
                <td>Catégorie / Filière</td>
                <td>
                   {{certif_qualite_tourisme.categoriefiliere}}
                </td>
              </tr>
            <tr>
                <td>Activité</td>
                <td>
                   {{certif_qualite_tourisme.activite}}
                </td>
              </tr>
              <tr>
                <td>Email</td>
                <td>
                   <a :href="`mailto:${ certif_qualite_tourisme.mail_etablissement }`" >{{certif_qualite_tourisme.mail_etablissement}}</a>
                </td>
              </tr>
             <tr>
                <td>Tel</td>
                <td>
                   {{certif_qualite_tourisme.telephone_etablissement}}
                </td>
              </tr>
             <tr>
                <td>Site</td>
                <td>
                   <a :href="certif_qualite_tourisme.site_web_etablissement" target="_blank">{{certif_qualite_tourisme.site_web_etablissement}}</a>
                </td>
              </tr>
            </tbody>
         </v-simple-table>


      </v-card-text>

      <v-card-title   v-if="this.etabs_qualite_tourisme != null"> Autres etablissement certifiés Qualité Tourisme</v-card-title>
      <v-card-text   v-if="this.etabs_qualite_tourisme != null" >
        <a href="https://www.qualite-tourisme.gouv.fr/" target="_blank">
        <img
                title="Etablissement certifié Qualité Tourisme"
                src="../../assets/logo_qualite_tourisme_etab.png"
        />
        </a>
          <v-data-table
              v-if="this.etabs_qualite_tourisme != null"
              dense
              :headers="headers"
              :items="etabs_qualite_tourisme"
              item-key="siret"
              class="elevation-1"
            >
             <template #item.siret="{ item }">
              <a :href="`/search/${ item.siret }?active=false`" > {{ item.siret}} </a>
             </template>

             <template #item.adressepostale="{ item }">{{ item.adresse}}<br>{{ item.codePostalEtablissement}} {{ item.libelleCommuneEtablissement}}</template>
             <template #item.info="{ item }">
               <span v-if="item.telephone_etablissement!=''">{{ item.telephone_etablissement }}</span>
               <br v-if="item.mail_etablissement">
               <a v-if="item.mail_etablissement" :href="`mailto:${ item.mail_etablissement }`" >{{item.mail_etablissement}}</a>
               <br v-if="item.site_web_etablissement" >
               <a v-if="item.site_web_etablissement" :href="item.site_web_etablissement" target="_blank">{{item.site_web_etablissement}}</a>
                </template>


            </v-data-table>

      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>

export default {
  name: "Tourisme",
  props: [""],
  components: {
  },
   data: () => ({
        search: '',
        filter: {},
        sortDesc: false,
        page: 1,
        itemsPerPage: 10,
    }),
  computed: {

   certif_qualite_tourisme: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualitetourisme_certificat", null, "valeur")

    },
    etabs_qualite_tourisme: function () {
      var listeEtab =  this.$store.getters.getbloc("certificats", "donnees", "qualitetourisme_etablissements", null, "valeur")
      if (listeEtab!=null && listeEtab.length ==1 && this.certif_qualite_tourisme!=null)
        return null // ne pas retourner la liste des autres etabs si & seul déjà mentionné dans certif_qualite_tourisme
      else
        return listeEtab
    },

    headers() {
      return [
        {
          text: "Siret",
          align: "start",
          value: "siret",
          fixed: true,
          width: "10px",
        },
          {
          text: "Activite",
          value: "activite",
          align: "start",
          fixed: true,
          width: "100px",
        },
          {
          text: "Categorie",
          value: "categoriefiliere",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Adresse",
          value: "adressepostale",
          align: "start",
          fixed: true,
          width: "100px",
        },
        {
          text: "Infos",
          value: "info",
          align: "start",
          fixed: true,
          width: "100px",
        },

      ];
    },
  },
  methods: {
    condition() {
      var certif =  this.certif_qualite_tourisme
      var etabs = this.etabs_qualite_tourisme
      return (certif !=null ) || (etabs !=null && etabs.length>0)
    },
     displaySelected(siret) {
        this.$store.dispatch('getEtablissement',siret)
    },
  },
};
</script>
